import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Contemporary_Period_-_Globalization.png';

function HistoryPageGlobalization() {
  return (
    <TopicPage
      topicKey="Globalization"
      title="History: Globalization"
      backgroundImage={bg}
      startRoute="/History-Globalization-Go"
      scrollLabels={[
        "Global Trade and Economy",
        "Cultural Exchange",
        "Global Organizations (e.g., UN, WTO)"
      ]}
      backRoute="/history-contemporary"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageGlobalization;
